import React, { useState } from 'react';
import { CancelButton, SubmitButton } from '../../components/mui/Buttons/Buttons';
import { Box, Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import useHandleApiResponse from '../../Hooks/useHandleApiResponse';
import { useDispatch } from 'react-redux';
import { updateTransactionDate } from '../../redux/features/refundSlice';
import { useSelector } from 'react-redux';

const ChangeTransactionDate = ({ rowData, nonEnrollment, setOpen, dispatchParams, apiAfterSuccess }) => {
  const { loading} = useSelector((state) => state.refund);
  const defaultDate = nonEnrollment ? rowData.holdamount_refund_transaction_date : rowData.expense_transaction_date;
  const apiHandler = useHandleApiResponse();
  const [selectedDate, setSelectedDate] = useState(defaultDate ? dayjs(defaultDate) : null);
  const dispatch = useDispatch();
  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      if (!selectedDate) return;
      const formattedDate = selectedDate.format('YYYY-MM-DD');
      const payload = {
        ...(nonEnrollment
          ? { holdamount_refund_id: rowData?.holdamount_refund_id }
          : { expense_id: rowData?.expense_id }),
        transaction_date: formattedDate,
      };
      const res = await dispatch(updateTransactionDate(payload));
      apiHandler(res, {
        onSuccess: () => {
          setOpen(false)
          dispatch(apiAfterSuccess(dispatchParams));
        },
      });
    } catch (error) {
      console.log('Error: ', error);
    }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box>
        <DatePicker
          label="Select Transaction Date"
          value={selectedDate}
          onChange={(v) => setSelectedDate(v)}
          sx={{ width: '100%', mb: 2 }}
          format="DD-MM-YYYY"
        />

        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <CancelButton action={handleCancel}>Cancel</CancelButton>
          <SubmitButton disabled={loading} action={handleSubmit}>
            {loading ? 'Submitting...' : 'Submit'}
          </SubmitButton>
        </Stack>
      </Box>
    </LocalizationProvider>
  );
};

export default ChangeTransactionDate;
